// @flow
import React from 'react';

import { Form, Input, Button, Checkbox, Divider } from 'antd';
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined';
import MinusCircleOutlined from '@ant-design/icons/lib/icons/MinusCircleOutlined';

export default function AddressForm({ required }: { required: boolean }) {
  return (
    <Form.List name="addresses">
      {(fields, { add, remove }) => (
        <div>
          {fields.map((field, index) => (
            <div key={field.key}>
              {index > 0 && <Divider />}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <strong>Address {index + 1}</strong>
                {index > 0 && (
                  <Button
                    type="link"
                    danger
                    onClick={() => remove(field.name)}
                    icon={<MinusCircleOutlined />}
                  >
                    Remove
                  </Button>
                )}
              </div>

              <Form.Item hidden={true} name={[field.name, 'id']}>
                <Input />
              </Form.Item>

              <Form.Item
                label="Label"
                name={[field.name, 'label']}
                rules={[
                  {
                    required: index > 0,
                    message: 'Please add a label for this address',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) return Promise.resolve();
                      const addresses = getFieldValue('addresses') || [];
                      const duplicates = addresses.filter(
                        (a, i) =>
                          a &&
                          a.label &&
                          i !== index &&
                          a.label.trim().toLowerCase() ===
                            value.trim().toLowerCase()
                      );
                      if (duplicates.length > 0) {
                        return Promise.reject(
                          new Error('Each address must have a unique label')
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Address"
                name={[field.name, 'address']}
                rules={[
                  {
                    required: index === 0 ? required : true,
                    message: 'Please Input an Address!',
                  },
                ]}
              >
                <Input placeholder="Address" />
              </Form.Item>
              <Form.Item name={[field.name, 'addressTwo']} label="Address Two">
                <Input placeholder="Address Two" />
              </Form.Item>
              <Form.Item
                label="City"
                name={[field.name, 'city']}
                rules={[
                  {
                    required: index === 0 ? required : true,
                    message: 'Please Input a City!',
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
              <Form.Item
                label="State"
                name={[field.name, 'state']}
                rules={[
                  {
                    required: index === 0 ? required : true,
                    message: 'Please Input a State!',
                  },
                ]}
              >
                <Input placeholder="State" />
              </Form.Item>
              <Form.Item
                label="Zip"
                name={[field.name, 'zip']}
                rules={[
                  {
                    required: index === 0 ? required : true,
                    message: 'Please Input a Zip!',
                  },
                ]}
              >
                <Input placeholder="Zip" pattern="[0-9]*" />
              </Form.Item>
              <Form.Item
                name={[field.name, 'isDefault']}
                valuePropName="checked"
              >
                <Checkbox>Default Address</Checkbox>
              </Form.Item>
            </div>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add({ isDefault: false })}
              block
              icon={<PlusOutlined />}
            >
              Add Another Address
            </Button>
          </Form.Item>
        </div>
      )}
    </Form.List>
  );
}
AddressForm.defaultProps = {
  required: true,
};
